import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=693c7e0c&"
import script from "./Disclaimers.vue?vue&type=script&lang=js&"
export * from "./Disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./Disclaimers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports